import { gql, TypedDocumentNode } from "@apollo/client";

import { AiProviderModels, QueryAvailableAiModelsArgs } from "types/generated";

export const GET_AVAILABLE_AI_MODELS: TypedDocumentNode<
  { availableAIModels: AiProviderModels[] },
  QueryAvailableAiModelsArgs
> = gql`
  query GetAvailableAiModels($provider: String) {
    availableAIModels(provider: $provider) {
      provider
      models
    }
  }
`;
